import { render, staticRenderFns } from "./Ajustes.vue?vue&type=template&id=fe324472&scoped=true"
import script from "./Ajustes.vue?vue&type=script&lang=js"
export * from "./Ajustes.vue?vue&type=script&lang=js"
import style0 from "./Ajustes.vue?vue&type=style&index=0&id=fe324472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe324472",
  null
  
)

export default component.exports